import { Button, Card, CardContent, Container, Divider, Grid, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { projects } from '../../projectsArr';
import './Projects.css';


const Projects = () => {
    return (
        <Box id="projects" sx={{ flexGrow: 1, py: 2, mt: { xs: '-1150px', md: '0px' } }}>
            <Container sx={{ textAlign: 'center', }}>
                <Typography sx={{ fontWeight: 500, mt: 5 }} variant="h6" component="div">
                    MY RECENT PROJECTS
                </Typography>
                <Typography sx={{ fontWeight: 400, letterSpacing: '1px', mb: '5px' }} variant="p" component="div">
                    Some web applications and websites built by me are listed below
                </Typography>
                <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                <Divider sx={{ width: '150px', p: 0, m: '4px auto 30px auto', border: '1px solid #FFFFFF4E' }} />
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>


                    {
                        projects.slice(0, 6).map(pr => (
                            <Grid data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1500"
                                item sx={{ mt: 1, }} xs={4} sm={4} md={4}>
                                <Box
                                    component="div"
                                    className={`box ${pr.imgClass}`}
                                />

                                <Card sx={{ minWidth: 300, height: '155px', backgroundColor: 'transparent', border: '1px solid #ffffff14', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', overflow: 'hidden', }}>

                                    <CardContent sx={{ mt: '-10px' }}>
                                        <Typography sx={{ color: 'whitesmoke', fontWeight: '500' }} variant="h6" component="div">
                                            {pr.title}
                                        </Typography>
                                        <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
                                        <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />

                                        {/* detais */}
                                        <Box style={{ textAlign: 'center' }}>

                                            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px', my: '15px' }}>
                                                <Link href={pr.live} target="_blank" underline="none">
                                                    <Button style={{ backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', padding: '5px', color: 'whitesmoke', width: '80px', textTransform: 'capitalize', }}>Live Site</Button>
                                                </Link>
                                                <Link sx={{ mx: 1 }} href={pr.frontend} target="_blank" underline="none">
                                                    <Button style={{ color: 'whitesmoke', width: '130px', textTransform: 'capitalize', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', padding: '5px', }}>Client Side Code</Button>
                                                </Link>
                                                {
                                                    pr.backend && <Link href={pr.backend} target="_blank" underline="none">
                                                        <Button style={{ color: 'whitesmoke', width: '130px', textTransform: 'capitalize', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', padding: '5px', }}>Sever Side Code</Button>
                                                    </Link>
                                                }
                                                <Link href={pr.route} target="_blank" underline="none">
                                                    <Button style={{ color: 'whitesmoke', width: '130px', textTransform: 'capitalize', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', padding: '5px', }}>View Details</Button>
                                                </Link>
                                            </Box>
                                        </Box>

                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    }

                    {/* Project 6 */}
                    {/* <Grid item sx={{ mt: 5 }} xs={4} sm={4} md={4}>
                        <Card sx={{ minWidth: 300, backgroundColor: 'gray', height: '210px' }}>

                            <CustomWidthTooltip1 title={project6}>
                                <CardMedia
                                    component="img"
                                    style={{ margin: '0 auto', height: '180px' }}
                                    image={img6}
                                    alt="green iguana"
                                />
                            </CustomWidthTooltip1>

                            <CardContent sx={{ mt: '-16px' }}>
                                <Typography sx={{ color: 'whitesmoke' }} variant="h6" component="div">
                                    Macbook Pro
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid> */}

                    <Link style={{ margin: '30px auto', }} href="/projects-gallery" underline="none">
                        <Button
                            data-aos="fade-up"
                            data-aos-easing="ease-out-cubic"
                            data-aos-duration="1500"
                            style={{ textTransform: 'capitalize', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', color: 'rgba(255, 255, 255, 0.689)', fontSize: '17px', fontWeight: '500' }}
                            type="button"
                            variant="contained"
                        >
                            More Projects

                        </Button>
                    </Link>

                </Grid>
            </Container>
        </Box >
    );
};

export default Projects;